import React from "react";
import { Link } from "react-router-dom";

export const feedbackColumns = (handleEdit, handleDelete, PAGE_SIZE) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Name",
    render: (row) => 
        <span>
          {row.name}
        </span>,    
  }
  ,
  {
    label: "Email",
    render: (row) => 
        <span>
          {row.email}
        </span>,    
  },
  {
    label: "Feedback",
    render: (row) => 
        <span>
          {row.feedback}
        </span>,    
  },
  {
    label: "Date",
    render: (row) => 
        <span>
          {row.date ? new Date(row.date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }) : "-"}
        </span>,    
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        {/* <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li> */}
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
  
  
];
